// src/components/PageList.jsx
import React, { useEffect, useState } from 'react';
import styles from './PageList.module.css';
import { API } from '../config';
import { useNavigate } from 'react-router-dom';

const PageList = () => {
  const [pages, setPages] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchPages = async () => {
      try {
        const res = await fetch(API.GET_PARENT_PAGES);
        const data = await res.json();
        if (data.success) {
          setPages(data.pages);
        }
      } catch (err) {
        console.error("Error fetching pages", err);
      }
    };

    fetchPages();
  }, []);

const handleDelete = async (id) => {
  if (!window.confirm("Are you sure you want to delete this page?")) return;

  try {
    const res = await fetch(`${API.DELETE_PAGE}?id=${id}`, {
      method: 'DELETE',
    });
    const data = await res.json();

    if (data.success) {
      alert("Page deleted");

      // If you're on PageList.jsx:
      setPages(pages.filter(p => p.id !== id));

      // If you're on ViewPage.jsx:
      navigate('/pagelist');
    } else {
      alert(data.message || "Failed to delete page.");
    }
  } catch (err) {
    console.error("Failed to delete", err);
    alert("Error while deleting.");
  }
};



  return (
    <div className={styles.pageList}>
      {pages.map(page => (
       <div
  className={styles.card}
  onClick={() => navigate(`/view/${page.id}`)}
  title="Click to view"
>
  <div className={styles.cardContent}>
    <h3>{page.title}</h3>
  </div>
</div>

      ))}
    </div>
  );
};

export default PageList;
